import Conclusionllustration from '@/assets/illustration/password_conclusion.svg'

export default {
  routeTitle: 'Alterar Senha',
  subtitle: 'Site: {domain}',
  user: {
    label: 'Usuário',
    placeholder: 'Selecione seu usuário'
  },
  password: {
    label: 'Nova Senha',
    placeholder: 'Digite sua nova senha'
  },
  confirmPassword: {
    label: 'Confirme a nova senha',
    placeholder: 'Digite sua nova senha'
  },
  button: 'Alterar a Senha',
  conclusion: {
    default: {
      title: 'Pronto! Sua senha foi alterada.',
      text: 'Você já pode acessar seu site com a nova senha.',
      illustration: Conclusionllustration
    },
    actions: [
      { title: 'Voltar para a lista de sites', outlined: 'true' },
      { title: 'Acessar meu site', href: '{ domain }/wp-admin', target: 'blank' }
    ]
  }
}
